module.exports = __webpack_public_path__ + "images/emails/bg-page-l-f0fc165c.gif";